function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30808",
  "data-name": "Group 30808"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5224",
  "data-name": "Rectangle 5224",
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5225",
  "data-name": "Rectangle 5225",
  width: 24,
  height: 24,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30811",
  "data-name": "Group 30811"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_30810",
  "data-name": "Group 30810"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59688",
  "data-name": "Path 59688",
  d: "M2,17v3H4V16H3A1,1,0,0,0,2,17Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59689",
  "data-name": "Path 59689",
  d: "M9,16H5v4l4.69-.01a.988.988,0,0,0,.89-.55l.87-1.9L9.86,14.06Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_30809",
  "data-name": "Group 30809"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59690",
  "data-name": "Path 59690",
  d: "M21.71,16.29A1,1,0,0,0,21,16H20v4h2V17A1,1,0,0,0,21.71,16.29Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_59691",
  "data-name": "Path 59691",
  d: "M13.6,12.84,17.65,4H14.3L12.54,7.97l-.49,1.1L12,9.21,9.7,4H6.35l4.05,8.84,1.52,3.32.08.18,1.42,3.1a.988.988,0,0,0,.89.55L19,20V16H15Z"
})));

function SvgSportsHockey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sports_hockey_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsHockey);
export default __webpack_public_path__ + "static/media/sports_hockey.09580587.svg";
export { ForwardRef as ReactComponent };